// extracted by mini-css-extract-plugin
export var addButton = "_f6-4";
export var contentBlockImage = "_f6-i";
export var contentBlockWidgetPreview = "_f6-g";
export var fulfillmentCutoffWidgetPreview = "_f6-9";
export var imageBackdrop = "_f6-6";
export var imageIcon = "_f6-8";
export var lowProfileImageContainer = "_f6-b";
export var lowProfileImageIcon = "_f6-f";
export var lowProfileImageIconContainer = "_f6-e";
export var lowProfileImagePlaceholder = "_f6-d";
export var lowProfileProductImage = "_f6-c";
export var lowProfileProductUpsellWidgetPreview = "_f6-a";
export var productCard = "_f6-5";
export var productImage = "_f6-7";
export var productReviewsWidgetPreview = "_f6-h";
export var progressBar = "_f6-1";
export var progressBarFill = "_f6-2";
export var progressBarTrack = "_f6-3";
export var shippingOptionWidgetPreview = "_f6-j";
export var shippingUpsellProgressBar = "_f6-k";
export var thresholdUpsellWidgetPreview = "_f6-0";